<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  <h1 class="section-header">
    {{ "MEDICAL_APPEAL_DETAILS_TITLE" | globalTranslate }}
  </h1>
  <hr />
  <section [formGroup]="getControl('data')">
    <div class="appellant-info">
      <p class="static-text case_num">
        <strong
          >{{ "MEDICAL_APPEAL_HOUSEHOLDMEMBER" | globalTranslate }}:
        </strong>
        {{ getValue("data.houseHoldMember") }}
      </p>
      <p class="static-text case_num">
        <strong>{{ "MEDICAL_APPEAL_FILER" | globalTranslate }}: </strong
        >{{
          getValue("data.filer") === "Self"
            ? translatedLang === "sp"
              ? "Para mí"
              : ("Self" | globalTranslate)
            : getValue("data.filer")
        }}
      </p>
      <p class="static-text">
        <strong>{{ "MEDICAL_APPEAL_DATE" | globalTranslate }}: </strong
        >{{ getValue("data.filingDate") | date: "MM/dd/yyyy" }}
      </p>
    </div>
    <h2 class="section-header mt-5">
      {{ "MA_HEADER_TEXT" | globalTranslate }}
    </h2>
    <hr />
    <!-- Paid out of pocket question - ONLY ALWAYS VISIBLE QUESTION AT FORM LOAD -->
    @if (isEnabled('data.paidOutOfPocketSw')) {
    <div class="row mt-4">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{
            'MEDICAL_APPEAL_PAID_OUT_OF_POCKET_QUESTION' | globalTranslate
          }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="paidOutOfPocketSw"
            [items]="tableCodeValue('YESNO', 'data.paidOutOfPocketSw')"
            [attr.aria-label]="
              'MEDICAL_APPEAL_PAID_OUT_OF_POCKET_QUESTION' | globalTranslate
            "
            formControlName="paidOutOfPocketSw"
            (change)="onChange('paidOutOfPocketSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if (isY('data.paidOutOfPocketSw')) {
    <div>
      @if (isEnabled('data.paidServiceTypeCd')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{ 'MEDICAL_APPEAL_PAID_SERVICE_TYPE' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="paidServiceTypeCd"
              [items]="tableCodeValue('CARERECEIVED', 'data.paidServiceTypeCd')"
              [attr.aria-label]="
                'MEDICAL_APPEAL_PAID_SERVICE_TYPE' | globalTranslate
              "
              formControlName="paidServiceTypeCd"
              (change)="onChange('paidServiceTypeCd')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      } @if (isEnabled('data.paidServiceDtlsTxt') &&
      getValue('data.paidServiceTypeCd')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{
              'MEDICAL_APPEAL_PAID_SERVICE_DETAILS' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="2000"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="paidServiceDtlsTxt"
                formControlName="paidServiceDtlsTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_PAID_SERVICE_DETAILS' | globalTranslate
                "
                rows="5"
                autofocus="true"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isN('data.paidOutOfPocketSw') &&
    isEnabled('data.hasExistingBillsSw')) {
    <div class="row mt-4">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{
            'MEDICAL_APPEAL_EXISTING_BILLS_QUESTION' | globalTranslate
          }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="hasExistingBillsSw"
            [items]="tableCodeValue('YESNO', 'data.hasExistingBillsSw')"
            [attr.aria-label]="
              'MEDICAL_APPEAL_EXISTING_BILLS_QUESTION' | globalTranslate
            "
            formControlName="hasExistingBillsSw"
            (change)="onChange('hasExistingBillsSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if (isY('data.hasExistingBillsSw')) {
    <div>
      @if (isEnabled('data.billedServiceTypeCd')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{ 'MEDICAL_APPEAL_BILLED_SERVICE_TYPE' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="billedServiceTypeCd"
              [items]="
                tableCodeValue('CARERECEIVED', 'data.billedServiceTypeCd')
              "
              [attr.aria-label]="
                'MEDICAL_APPEAL_BILLED_SERVICE_TYPE' | globalTranslate
              "
              formControlName="billedServiceTypeCd"
              (change)="onChange('billedServiceTypeCd')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      } @if (isEnabled('data.billedServiceDtlsTxt') &&
      getValue('data.billedServiceTypeCd')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{
              'MEDICAL_APPEAL_BILLED_SERVICE_DETAILS' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="2000"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="billedServiceDtlsTxt"
                formControlName="billedServiceDtlsTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_BILLED_SERVICE_DETAILS' | globalTranslate
                "
                rows="5"
                autofocus="true"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isN('data.hasExistingBillsSw')) {
    <div>
      @if (isEnabled('data.deniedRqstdCareSw')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{
              'MEDICAL_APPEAL_DENIED_CARE_QUESTION' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="deniedRqstdCareSw"
              [items]="tableCodeValue('YESNO', 'data.deniedRqstdCareSw')"
              [attr.aria-label]="
                'MEDICAL_APPEAL_DENIED_CARE_QUESTION' | globalTranslate
              "
              formControlName="deniedRqstdCareSw"
              (change)="onChange('deniedRqstdCareSw')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      } @if (isY('data.deniedRqstdCareSw')) {
      <div>
        @if (isEnabled('data.alrdyRcvdDeniedCareSw')) {
        <div class="row mt-4">
          <div class="col">
            <nh-field
              class="label-section"
              label="{{
                'MEDICAL_APPEAL_ALREADY_RECEIVED_DENIED_CARE' | globalTranslate
              }}"
              [mandatory]="true"
              [attr.aria-required]="true"
            >
              <select
                nhTranslate
                name="alrdyRcvdDeniedCareSw"
                [items]="tableCodeValue('YESNO', 'data.alrdyRcvdDeniedCareSw')"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_ALREADY_RECEIVED_DENIED_CARE'
                    | globalTranslate
                "
                formControlName="alrdyRcvdDeniedCareSw"
                (change)="onChange('alrdyRcvdDeniedCareSw')"
                required
              ></select>
            </nh-field>
          </div>
        </div>
        } @if (isN('data.alrdyRcvdDeniedCareSw')) {
        <div>
          @if (isEnabled('data.deniedServiceTypeCd')) {
          <div class="row mt-4">
            <div class="col">
              <nh-field
                class="label-section"
                label="{{
                  'MEDICAL_APPEAL_DENIED_SERVICE_TYPE' | globalTranslate
                }}"
                [mandatory]="true"
                [attr.aria-required]="true"
              >
                <select
                  nhTranslate
                  name="deniedServiceTypeCd"
                  [items]="
                    tableCodeValue('CARERECEIVED', 'data.deniedServiceTypeCd')
                  "
                  [attr.aria-label]="
                    'MEDICAL_APPEAL_DENIED_SERVICE_TYPE' | globalTranslate
                  "
                  formControlName="deniedServiceTypeCd"
                  (change)="onChange('deniedServiceTypeCd')"
                  required
                ></select>
              </nh-field>
            </div>
          </div>
          } @if (isEnabled('data.aplDtlsMedDentalTxt') &&
          getValue('data.deniedServiceTypeCd')?.code !== 'PH') {
          <div class="row mt-4">
            <div class="col">
              <nh-field
                label="{{
                  'MEDICAL_APPEAL_DENIED_SERVICE_DETAILS' | globalTranslate
                }}"
                [mandatory]="true"
                [attr.aria-required]="true"
              >
                <nh-count>
                  <textarea
                    (input)="onInput($event)"
                    maxlength="2000"
                    [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                    class="form-control"
                    name="aplDtlsMedDentalTxt"
                    formControlName="aplDtlsMedDentalTxt"
                    [attr.aria-label]="
                      'MEDICAL_APPEAL_DENIED_SERVICE_DETAILS' | globalTranslate
                    "
                    rows="5"
                    autofocus="true"
                    required
                  >
                  </textarea>
                </nh-count>
              </nh-field>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    } @if (getValue('data.deniedServiceTypeCd')?.code === 'PH') {
    <div>
      @if (isEnabled('data.medDeniedAssignedPharmacySw')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{
              'MEDICAL_APPEAL_PHARMACY_LOCKIN_QUESTION' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="medDeniedAssignedPharmacySw"
              [items]="
                tableCodeValue('YESNO', 'data.medDeniedAssignedPharmacySw')
              "
              [attr.aria-label]="
                'MEDICAL_APPEAL_PHARMACY_LOCKIN_QUESTION' | globalTranslate
              "
              formControlName="medDeniedAssignedPharmacySw"
              (change)="onChange('medDeniedAssignedPharmacySw')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isY('data.alrdyRcvdDeniedCareSw') || isN('data.deniedRqstdCareSw')) {
    <div>
      @if (isEnabled('data.missedShiftCareSw')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{
              'MEDICAL_APPEAL_INHOME_CARE_QUESTION' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="missedShiftCareSw"
              [items]="tableCodeValue('YESNO', 'data.missedShiftCareSw')"
              [attr.aria-label]="
                'MEDICAL_APPEAL_INHOME_CARE_QUESTION' | globalTranslate
              "
              formControlName="missedShiftCareSw"
              (change)="onChange('missedShiftCareSw')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isY('data.missedShiftCareSw')) {
    <div>
      @if (isEnabled('data.kindOfInHomeCareCd')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{ 'MEDICAL_APPEAL_INHOME_CARE_TYPE' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <div
              class="checkbox-group"
              role="group"
              [attr.aria-label]="
                'MEDICAL_APPEAL_INHOME_CARE_TYPE' | globalTranslate
              "
            >
              @for (option of inHomeCareOptions; track option) {
              <div class="py-2 pb-md-1 checkbox">
                <label class="form-check-label ms-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    tabindex="0"
                    [id]="'inHomeCare_' + option?.code"
                    [name]="'kindOfInHomeCareCd_' + option?.code"
                    [value]="option?.code"
                    [checked]="isInHomeCareSelected(option?.code)"
                    (change)="onInHomeCareCheckboxChange(option, $event)"
                  />
                  <span class="cr" role="presentation" aria-hidden="true"
                    ><i class="cr-icon fa fa-check" aria-hidden="true"></i
                  ></span>
                  <span class="checkbox-l">{{ option.value | globalTranslate }}</span>
                </label>
              </div>
              }
            </div>
          </nh-field>
        </div>
      </div>
      } @if (isEnabled('data.inHomeCareTypeOthTxt') &&
      isInHomeCareSelected('OT')) {
      <div class="row mt-4">
        <div class="col">
          <p class="label-section mb-1" [attr.aria-required]="true">
            <span class="text-danger" aria-hidden="true" tabindex="-1">*</span>{{'OTHER_HOME' | globalTranslate}}</p>
            <!--passing the mandatory flag as false to hide the asterisk only-->
          <nh-field label="{{'MEDICAL_APPEAL_INHOME_CARE_OTHER' | globalTranslate}}" class="other_label" [mandatory]="false" [attr.aria-required]="true">
            <nh-count>
              <textarea (input)="onInput($event)" maxlength="200" [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate" 
                        class="form-control" name="inHomeCareTypeOthTxt" formControlName="inHomeCareTypeOthTxt" [attr.aria-label]="'MEDICAL_APPEAL_INHOME_CARE_OTHER' | globalTranslate" rows="3" required>
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isN('data.missedShiftCareSw')) {
    <div>
      @if (isEnabled('data.assignedPharmacyRequiredSw')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{
              'MEDICAL_APPEAL_ASSIGNED_PHARMACY_REQUIRED' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="assignedPharmacyRequiredSw"
              [items]="
                tableCodeValue('YESNO', 'data.assignedPharmacyRequiredSw')
              "
              [attr.aria-label]="
                'MEDICAL_APPEAL_ASSIGNED_PHARMACY_REQUIRED' | globalTranslate
              "
              formControlName="assignedPharmacyRequiredSw"
              (change)="onChange('assignedPharmacyRequiredSw')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isY('data.medDeniedAssignedPharmacySw') ||
    isY('data.assignedPharmacyRequiredSw')) {
    <div>
      @if (isEnabled('data.pharmacyRequestTypeCd')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            class="label-section"
            label="{{
              'MEDICAL_APPEAL_PHARMACY_REQUEST_TYPE' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <select
              nhTranslate
              name="pharmacyRequestTypeCd"
              [items]="
                tableCodeValue('PHARMACYCHANGE', 'data.pharmacyRequestTypeCd')
              "
              [attr.aria-label]="
                'MEDICAL_APPEAL_PHARMACY_REQUEST_TYPE' | globalTranslate
              "
              formControlName="pharmacyRequestTypeCd"
              (change)="onChange('pharmacyRequestTypeCd')"
              required
            ></select>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (isN('data.medDeniedAssignedPharmacySw')) {
    <div>
      @if (isEnabled('data.aplDtlsNoLockinRsnTxt')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{ 'MEDICAL_APPEAL_NO_LOCKIN_DETAILS' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="2000"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="aplDtlsNoLockinRsnTxt"
                formControlName="aplDtlsNoLockinRsnTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_NO_LOCKIN_DETAILS' | globalTranslate
                "
                rows="5"
                autofocus="true"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (getValue('data.pharmacyRequestTypeCd')?.code === 'CDP') {
    <div>
      @if (isEnabled('data.currentPharmacyChngRsnTxt')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{ 'MEDICAL_APPEAL_PHARMACY_CURRENT' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="1200"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="currentPharmacyChngRsnTxt"
                formControlName="currentPharmacyChngRsnTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_PHARMACY_CURRENT' | globalTranslate
                "
                rows="3"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      } @if (isEnabled('data.rqstdPharmacyTxt')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{ 'MEDICAL_APPEAL_PHARMACY_REQUESTED' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="1200"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="rqstdPharmacyTxt"
                formControlName="rqstdPharmacyTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_PHARMACY_REQUESTED' | globalTranslate
                "
                rows="3"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      } @if (isEnabled('data.pharmacyChngRsnTxt')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{
              'MEDICAL_APPEAL_PHARMACY_CHANGE_REASON' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="1200"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="pharmacyChngRsnTxt"
                formControlName="pharmacyChngRsnTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_PHARMACY_CHANGE_REASON' | globalTranslate
                "
                rows="3"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      }
    </div>
    } @if (getValue('data.pharmacyRequestTypeCd')?.code === 'RPL') {
    <div>
      @if (isEnabled('data.currentPharmacyRmvLockinTxt')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{ 'MEDICAL_APPEAL_PHARMACY_CURRENT' | globalTranslate }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="1200"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="currentPharmacyRmvLockinTxt"
                formControlName="currentPharmacyRmvLockinTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_PHARMACY_CURRENT' | globalTranslate
                "
                rows="3"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      } @if (isEnabled('data.rmvLockinRsnTxt')) {
      <div class="row mt-4">
        <div class="col">
          <nh-field
            label="{{
              'MEDICAL_APPEAL_PHARMACY_REMOVE_REASON' | globalTranslate
            }}"
            [mandatory]="true"
            [attr.aria-required]="true"
          >
            <nh-count>
              <textarea
                (input)="onInput($event)"
                maxlength="1200"
                [placeholder]="'NOTE_PLACEHOLDER' | globalTranslate"
                class="form-control"
                name="rmvLockinRsnTxt"
                formControlName="rmvLockinRsnTxt"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_PHARMACY_REMOVE_REASON' | globalTranslate
                "
                rows="3"
                required
              >
              </textarea>
            </nh-count>
          </nh-field>
        </div>
      </div>
      }
    </div>
    }
  </section>
</nh-form>